module.exports = __webpack_public_path__ + "asset/image-iconCategoryFitness-1de406878709f904.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/iconCategoryFitness.svg
// module id = gGI1
// module chunks = 0